import APIBase from "./apiBase";

export const refreshPubSub = async (inboxId: string) => {
  const { data } = await APIBase.post(
    `/inboxes/create-pub-sub-watcher/${inboxId}`,
  );
  return data;
};

export const fetchAllMail = async (inboxId: string) => {
  const { data } = await APIBase.post(
    `/inboxes/${inboxId}/ingest-all-mail/500`,
  );
  return data;
};

export const resendWelcomeEmail = async (userId: string) => {
  const { data } = await APIBase.post(`/users/${userId}/resend-welcome-email`);
  return data;
};
